const isTestUserChoice = [
    { id: true, name: "Sim" },
    { id: false, name: "Não" },
]

export default isTestUserChoice;
